import type { TestSession } from '../data/projectTypes'

/** A closed session has stopped scheduling work; its explorations may still have ended unsuccessfully. */
export function testSessionStatus(session: Pick<TestSession, 'status' | 'explorations' | 'access_wait'>): string {
  // An open access wait suspends the round at a target-site challenge: the stored status still says
  // 'in-progress', but nothing is executing — show the wait so every status surface agrees with the
  // chat's access request card instead of a live running line (bug bug-mv8an0zd-xt4j).
  if (session.status === 'in-progress' && session.access_wait) return 'awaiting-access'
  if (session.status !== 'completed') return session.status
  const statuses = new Set(session.explorations.map(exploration => exploration.status))
  if (statuses.has('failed')) return 'failed'
  if (statuses.has('blocked')) return 'blocked'
  if (statuses.has('cancelled')) return 'cancelled'
  return session.status
}
